import { render, staticRenderFns } from "./LoanSupplierDetail.vue?vue&type=template&id=0f495e78&"
import script from "./LoanSupplierDetail.vue?vue&type=script&lang=js&"
export * from "./LoanSupplierDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports